import api from "api";

export const buscarDadosDesvioPadrao = async (tarefaID) => {
  const res = await api.get(`/backoffice/buscarDadosDesvioPadrao/${tarefaID}`, {
    token: 'gecro'  
  });
  return res.data;
};
